const CASH_FUND_COMPLETION_MESSAGE_INDEX = 1;

export const getCompletionMessageIndex = (repeatableNumber: number, messageCount: number, isCashOrCharityFund: boolean): number => {
  if (messageCount <= 0) {
    return 0;
  }

  if (isCashOrCharityFund) {
    return repeatableNumber % messageCount;
  }

  const eligibleIndexes = Array.from({ length: messageCount }, (_, index) => index).filter(index => index !== CASH_FUND_COMPLETION_MESSAGE_INDEX);

  return eligibleIndexes[repeatableNumber % eligibleIndexes.length];
};
